import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role'

import { useFetchInitCalendar } from './hooks';
import { Card, CardContent } from '@mui/material';

import { Calendar } from './Calendar'
import { ModalModule } from './ModalModule'

export const AgendaAbogacia = () => {

    const location = useLocation();
    const paramsURL = useParams();

    const useFetchInit = useFetchInitCalendar({location, paramsURL})

    return (
        <AllowedAccess permissions={['251_JURIDICO']} renderAuthFailed={<p>Error</p>}>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <ModalModule useFetchInit={useFetchInit} />
                    <Calendar useFetchInit={useFetchInit} />
                </CardContent>
            </Card>
        </AllowedAccess>
    )
}
